const apiUrl = process.env.REACT_APP_API_URL;

const locationApiUrl = 'https://www.google.com/maps/search/?api=1&query=';

export const composeApiUrl = (url) => `${apiUrl}${url}`;

export const composeLocationApiUrl = (location) => (location && `${locationApiUrl}${location.latitude},${location.longitude}`);
